import EditLocationModal from './EditLocationModal';

export default EditLocationModal;
